import { createContext, useContext, useRef } from 'react';
import { useImmerReducer } from 'use-immer';
import { DispatchAction, SurveyState, UserResponse } from '../Common';
import { DataService_Domain_Models_ErrorCodes } from '../api';

const SurveyInitialState: SurveyState = {
  IsLoading:false,
  IsAPIError:false,
  APIError:{},
  APIStatusCode : 0,
  StartSurvey: {},
  ProgressBarCounter: 0,
  FirstCommandIndex:0,
  NextQuestion: {},
  IsComplete:false,
  ValidationErrors:[],
  IsTimeOut:false,
  RedirectUrl:"",
  currentPanelistSchedule:{},
  AvailableSessions:{},
  panelistTimeZone:"",
};

function SurveyReducer(draft: SurveyState, action: DispatchAction) {
  switch (action.type) {
    case "reset":
      draft = action.value;
      break;
    case "SetFirstCommandIndex":
      draft.FirstCommandIndex = action.value;
      break;
    case "SetStartSurvey":
      draft.StartSurvey = action.value;
      break;
    case "SetProgressBarCounter":
      draft.ProgressBarCounter=action.value;
      break;
    case "IncrementProgress":
      draft.ProgressBarCounter++;
      break;
    case "DecrementProgress":
      if(draft.ProgressBarCounter > 0)
        draft.ProgressBarCounter--;
      break;
    case "SetNextQuestion":
      draft.NextQuestion = action.value;
      break;
    case "setLoading":
      draft.IsLoading = action.value;
      break;
    case "SetAPIError":
      draft.IsAPIError = true;
      draft.APIError.success = action.value.body.success??false;
      draft.APIError.errorCode = action.value.body.errorCode??DataService_Domain_Models_ErrorCodes.INTERNAL_ERROR;
      draft.APIError.msg = action.value.body.msg??"Internal Error";
      draft.APIStatusCode = action.value.status;
      break;
    case "SetStartError":
      draft.IsAPIError = true;
      draft.APIError.success = false;
      draft.APIError.errorCode = DataService_Domain_Models_ErrorCodes.SURVEY_INITILIZATION_ERROR;
      draft.APIError.msg = "Invalid Input";
      draft.APIStatusCode = 400;
      break;      
    case "clearAPIError":
      draft.IsAPIError = false;
      draft.APIError = {};
      draft.APIStatusCode = 0;            
      break;
    case "setComplete":
      draft.IsComplete = action.value;
      break;
                         
    case "addValidationError":
      const addIndex = draft.ValidationErrors.findIndex(error => error.commandIndex === action.value.commandIndex)
      if (addIndex !== -1) draft.ValidationErrors.splice(addIndex, 1)
      draft.ValidationErrors.push(action.value);
      break;
    case "removeValidationError":
      const index = draft.ValidationErrors.findIndex(error => error.commandIndex === action.value.commandIndex)
      if (index !== -1) draft.ValidationErrors.splice(index, 1)
      break;
    case "clearValidationError":
      draft.ValidationErrors = [];
      break;
    case "setTimeout":
      draft.IsTimeOut= true;
      break;
    case "clearTimeout":
      draft.IsTimeOut= false;
      break;    
    case "RedirectURL":
      draft.RedirectUrl= action.value;
      break;     
    case "currentSchedule":
      draft.currentPanelistSchedule = action.value
      break;
    case "availableSessions":
      draft.AvailableSessions = action.value
      break;
    case "timeZone":
      draft.panelistTimeZone = action.value
      break;                            
    default:
      console.log("Unknown Action value:"+action.type)
      break;
  }
}
const SurveyContext = createContext(SurveyInitialState);

const SurveyDispatchContext = createContext<React.Dispatch<DispatchAction>>(() => { });

const SurveyUserResponseContext = createContext<React.MutableRefObject<UserResponse>>({current:[]});

export function SurveyContextProvider({ children }: any) {

  const [state, dispatch] = useImmerReducer(SurveyReducer, SurveyInitialState);
  const userResponse = useRef<UserResponse>([]);

  return (
    <SurveyContext.Provider value={state}>
      <SurveyDispatchContext.Provider value={dispatch}>
        <SurveyUserResponseContext.Provider value={userResponse}>
        {children}
        </SurveyUserResponseContext.Provider>
      </SurveyDispatchContext.Provider>
    </SurveyContext.Provider>
  );
}

export function useSurveyCtx() {
  return useContext(SurveyContext);
}

export function useSurveyCtxDispatch() {
  return useContext(SurveyDispatchContext);
}

export function useUserResponseCtx() {
  return useContext(SurveyUserResponseContext);
}
